import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IArticoloPortaleOloFE } from "@common/interfaces/olo";
import { Topics } from '@common/interfaces/topics';
import { RealtimeConnectionService } from '@ep-om/realtime-v2/realtime-connection.service';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ArticoloPortaleOloQuery } from './articoloPortaleOlo.query';
import { ArticoloPortaleOloStore } from './articoloPortaleOlo.store';
import { LastUpdateQuery } from '../lastUpdate/lastUpdate.query';
import { LastUpdateService } from '../lastUpdate/lastUpdate.service';

@Injectable({
  providedIn: 'root'
})
export class ArticoloPortaleOloService {
  private apiUrl = environment.apiUrl;
  constructor(
    private store: ArticoloPortaleOloStore,
    public query: ArticoloPortaleOloQuery,
    private lastUpdateQuery: LastUpdateQuery,
    private lastUpdateService: LastUpdateService,
    private realtimeConnection: RealtimeConnectionService,
    private http: HttpClient,
  ) {
    // Entita' "calcolata", mai pubblicata dai motori realtime: pull HTTP con cursore lastUpdate
    // ad ogni (ri)connessione del motore attivo, qualunque esso sia.
    this.realtimeConnection.uponConnection$.pipe(
      switchMap(_ => {
        const lastUpdates = this.lastUpdateQuery.getValue();
        const key = Topics.ARTICOLO_PORTALE_OLO_FE;
        const lastUpdateQueryParams = lastUpdates ? lastUpdates[key] : null;
        const url = this.apiUrl + '/api/articoloPortaleOlo' + (!!lastUpdateQueryParams?.lastUpdate
          ? '?date=' + encodeURIComponent(lastUpdateQueryParams?.lastUpdate) : '');
        return this.http.get<IArticoloPortaleOloFE[]>(url)
      }),
    ).subscribe(updates => {
      this.lastUpdateService.setStoreLive(this.store.storeName);
      if (!updates || !updates.length) return;
      this.store.upsertMany(updates);
      // BE ordina per 'updated_at' DESC
      const lastItem = updates.at(0);

      if (!lastItem) return;

      const updateStatus = {
        lastUpdate: lastItem.updatedAt,
        remaining: 0,
        total: updates.length,
        lastId: lastItem.id
      };
      this.lastUpdateService.setLastUpdate(this.store.storeName, updateStatus);
    })
  }

  getArticoloById(id: string): IArticoloPortaleOloFE {
    return this.query.getEntity(id);
  }
}


